import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'timeElapsed' })
export class TimeElapsedPipe implements PipeTransform {
  public transform(dateStr: string): any {
    const date = new Date(dateStr);
    let result: string;
    if (!dateStr || date.getFullYear() == 1970) { return 'never'; }

    // current time
    const now = new Date().getTime();

    // time since message was sent in seconds
    const delta = (now - date.getTime()) / 1000;

    if (delta < 10) {
      result = 'now';
    } else if (delta < 60) {
      result = Math.floor(delta) + ' seconds ago';
    } else if (delta < 3600) {
      result = Math.floor(delta / 60) + ' minutes ago';
    } else if (delta < 86400) {
      result = Math.floor(delta / 3600) + ' hours ago';
    } else {
      result = Math.floor(delta / 86400) + ' days ago';
    }

    return result;
  }
}
